import {
    suggestNextSteps,
    summarize,
    summarizeAndReply,
    type Suggestions,
} from '../utils/suggestionCatalog';

export function getSelectedReadingPaneSuggestions(): Suggestions {
    return [summarize, summarizeAndReply, suggestNextSteps];
}
